import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./CadastrarVagasEstagio2.css";
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import CadastroVagasHeader from '../../../components/Cadastrar-Vagas/CadastroVagasHeader';
import CadastroVagasForm from '../../../components/Cadastrar-Vagas/CadastroVagasForm';
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";

const CadastrarVagas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [areaCursos, setAreaCursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userData = await apiService.getCurrentUser();
        console.log(userData);
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);

        if (userData.cargoId === 1) {
          const estabelecimentosData = await apiService.getEstabelecimentosSaude();
          setEstabelecimentos(estabelecimentosData || []);
        } else if (userData.estabelecimentoSaudeId) {
          const estabelecimentoData = await apiService.getEstabelecimentosSaudeId(userData.estabelecimentoSaudeId);
          setEstabelecimentos(estabelecimentoData ? [estabelecimentoData] : []);
        }

        const cursosData = await apiService.getAreaCursos();
        setAreaCursos(cursosData || []);
      } catch (err) {
        console.error('Erro ao buscar dados:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleVoltar = () => {
    navigate(location.state?.returnPath || '/VagasDisponibilizadas');
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <div className="CadastrarEspecialidades-Page">
      <div className="navbar">
        <Navbar onLogout={apiService.logout} />
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={sidebarItems} />
        </div>
        <div className="main-content">
          <CadastroVagasHeader />
          <CadastroVagasForm 
            user={user}
            estabelecimentos={estabelecimentos}
            areaCursos={areaCursos}
            onVoltar={handleVoltar}
          />
        </div>
      </div>
    </div>
  );
};

export default CadastrarVagas;
